module.exports = __webpack_public_path__ + "static/gainsborough logo-5e23bc85bdde3971e84cde93f1a27619.png";